var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header-row"},[_c('a',{staticClass:"logo"}),_c('span',[_vm._v("\n        Zapłać on-line za kod doładowania przedpłatowego licznika energii "),_c('sup',[_vm._v("(1)")])])])])])
}]

export { render, staticRenderFns }